import React from "react";
import { NavLink } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Container, Row, Col, NavItem } from "reactstrap";
import env from "@beam-australia/react-env";
import { ApplicationStateConsumer } from "./ApplicationStateProvider";
import "./MainFooter.scss";
import headerSetting from "./catalog/catalogSettings.json";

const MainFooter = () => {
  const { i18n } = useTranslation();

  const renderLinks = lang => {
    const headerLinksLang = headerSetting[lang]
      ? headerSetting[lang]
      : headerSetting.default;

    return headerLinksLang.map((c, index) => (
      <NavItem key={`nav-${index}`}>
        <NavLink to={c.link}>{c.name}</NavLink>
      </NavItem>
    ));
  };

  return (
    <ApplicationStateConsumer>
      {({ authenticated }) => (
        <footer className="footer p-4" id="footer">
          <Container>
            <Row>
              <Col md={4} className="footer-logo text-left mr-auto">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 918 177">
                  <path d="M3 132a3 3 0 0 1-3-3V30a3 3 0 0 1 3-3h48a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H18a3 3 0 0 0-3 3v69a3 3 0 0 0 3 3h91a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3zm154 0a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h91a3 3 0 0 0 3-3V44a3 3 0 0 0-3-3h-33a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h48a3 3 0 0 1 3 3v100a3 3 0 0 1-3 3z" />
                  <path d="M128.06 132a3 3 0 0 1-3-3v-22a3 3 0 0 0-3-3H70a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h126a3 3 0 0 1 3 3v98a3 3 0 0 1-3 3h-52a3 3 0 0 0-3 3v22a3 3 0 0 1-3 3zM181 89a3 3 0 0 0 3-3V18a3 3 0 0 0-3-3H85a3 3 0 0 0-3 3v68a3 3 0 0 0 3 3zm131-60.12a3 3 0 0 1 2.87-2.88h10a2.87 2.87 0 0 1 2.88 2.88v42.25H383V28.88a2.87 2.87 0 0 1 2.89-2.88h10a3 3 0 0 1 2.87 2.88v100.24a3 3 0 0 1-2.87 2.88h-10a2.87 2.87 0 0 1-2.87-2.88V85.36h-55.3v43.76a2.87 2.87 0 0 1-2.88 2.88h-10a3 3 0 0 1-2.87-2.88zm100.73 8.79a8.71 8.71 0 0 1 8.61-9 8.89 8.89 0 1 1 0 17.78 8.67 8.67 0 0 1-8.61-8.78zm1.66 36.23a3 3 0 0 1 2.87-2.9h8.62a3 3 0 0 1 2.87 2.9v55.2a3 3 0 0 1-2.87 2.9h-8.62a3 3 0 0 1-2.87-2.9zm26.88 49.8l3.18-5.85a2.61 2.61 0 0 1 3.77-.75s6.65 3.9 14.06 3.9c4.53 0 7.4-1.8 7.4-5.1 0-4.05-3.32-6-11.63-9.75-9.37-4.05-17.23-9.75-17.23-19.65 0-7.5 6.2-16.5 20.7-16.5a34.07 34.07 0 0 1 17.83 4.65 3.33 3.33 0 0 1 1.21 4.35l-2.72 5.1a3.19 3.19 0 0 1-3.93 1.2s-6.64-3.15-12.39-3.15c-5.13 0-6.8 2.25-6.8 4.5 0 3.9 3.78 5.55 9.67 8.1 11 4.8 20.1 9.45 20.1 20.7 0 9.3-8.91 17.55-22.36 17.55-10.13 0-16.78-3.6-19.95-6.15a2.52 2.52 0 0 1-.91-3.15zm57.8-40.26h-6.34a2.88 2.88 0 0 1-2.87-2.88v-6.82a2.78 2.78 0 0 1 2.87-2.88h6.34V54a3 3 0 0 1 2.93-2.85l8.61-.15a2.84 2.84 0 0 1 2.72 2.88v17h15.41a2.78 2.78 0 0 1 2.87 2.88v6.82a2.88 2.88 0 0 1-2.87 2.88h-15.46v30c0 5.15 2 6.06 4.83 6.06 3.18 0 7.41-1.82 9.22-2.73 2-.91 2.87 0 3.48 1.37l2.72 6.66a2.52 2.52 0 0 1-1.36 3.64c-1.51.91-10.43 4.55-17.68 4.55-11.94 0-15.42-7.28-15.42-18zM568.24 70c16.92 0 30.52 14.4 30.52 31.35 0 17.25-13.6 31.65-30.52 31.65s-30.53-14.4-30.53-31.65c0-16.95 13.6-31.35 30.53-31.35zm0 50.1c9.52 0 17.07-8.4 17.07-18.75 0-10-7.55-18.3-17.07-18.3s-17.08 8.25-17.08 18.3c0 10.35 7.56 18.75 17.08 18.75zM611 74.15a3 3 0 0 1 2.88-2.89h4.38a2.89 2.89 0 0 1 2.57 2.13l1.66 5.16a21.51 21.51 0 0 1 17.68-8.81c5.74 0 12.69 1.52 11 5.62l-3.63 7.45a2.56 2.56 0 0 1-3.54 1.37 13.71 13.71 0 0 0-5.14-1.07 15.91 15.91 0 0 0-13.6 7.45v38.61c0 2.58-1.66 2.89-4.08 2.89h-7.25a3 3 0 0 1-2.88-2.89zm44.84.79A2.67 2.67 0 0 1 658.4 71h9.93a3.26 3.26 0 0 1 2.56 1.67L689.56 113h.15l18.07-40.28c.6-1.37 1.8-1.67 3.16-1.67h8.58c2.41 0 3.61 2 2.56 3.94L676 175.18a3 3 0 0 1-2.56 1.82h-9a2.71 2.71 0 0 1-2.56-4.09L682 129.45zm76.05-46.06a2.87 2.87 0 0 1 2.87-2.88h10a3 3 0 0 1 2.88 2.88v89h40.95a2.87 2.87 0 0 1 2.87 2.87v8.33a2.87 2.87 0 0 1-2.87 2.88h-53.8a2.87 2.87 0 0 1-2.87-2.88zm89.52 64.67a43.75 43.75 0 0 1 11.93 1.8c.15-9.45-1.66-13.2-9.37-13.2a64.59 64.59 0 0 0-16.92 2.7c-1.81.45-2.87-.75-3.33-2.4l-1.2-5.55a2.69 2.69 0 0 1 2-3.45A62.74 62.74 0 0 1 825.33 70c19.35 0 21.16 11.7 21.16 26.7v32.46a3 3 0 0 1-2.87 2.84h-4.23c-1.36 0-1.77-.59-2.37-2.09l-1.71-4.56a26.18 26.18 0 0 1-18.59 7.65c-11.33 0-19.49-7.65-19.49-20.1 0-10.9 8.77-19.35 24.18-19.35zm-1.82 28.8c6 0 11.79-4.5 13.6-7.5v-9.6a22.9 22.9 0 0 0-10.58-2.4c-7.25 0-12.24 3.75-12.24 9.9 0 5.4 3.63 9.6 9.22 9.6zm39.63-93.49a3 3 0 0 1 2.87-2.86h8.76a3 3 0 0 1 2.87 2.86V73a36.48 36.48 0 0 1 14.51-3.32c16.77 0 29.77 14 29.77 31.65 0 17.33-12.24 31.65-28.26 31.65a27 27 0 0 1-19.19-8.44l-1.41 4.88c-.45 1.58-1.14 2.58-2.52 2.58h-4.53a3 3 0 0 1-2.87-2.86zM887.93 120c9.67 0 16-8.59 16-18.69s-7.11-18.53-17.23-18.53a25.93 25.93 0 0 0-13.15 3.46V111c.78 1.66 5.16 9 14.38 9z" />
                </svg>
              </Col>
              <Col sm="auto" className="footer-navigation">
                <ul>
                  {authenticated && (
                    <li>
                      <NavLink to="/tridy">
                        <Trans i18nKey="mainHeader.myClasses" />
                      </NavLink>
                    </li>
                  )}
                  {renderLinks(i18n.language)}
                </ul>

                <ul>
                  <li>
                    <a
                      href="https://historylab.cz/blog/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Trans i18nKey="blog.blog">Blog</Trans>
                    </a>
                  </li>

                  <li>
                    <a href="https://metodika.historylab.cz">
                      <Trans i18nKey="methodology.original">
                        Promýšlet dějiny
                      </Trans>
                    </a>
                  </li>

                  <li>
                    <a
                      href={`${env("SERVER_URL")}/pdf/metodika-historylabu.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Trans i18nKey="methodology.pdf">
                        Metodika k HistoryLabu
                      </Trans>
                    </a>
                  </li>

                  <li>
                    <a
                      href={`${env("SERVER_URL")}/pdf/evaluacni-zprava.pdf`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Trans i18nKey="evaluationStudy">
                        Evaluační studie projektu HistoryLab
                      </Trans>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </footer>
      )}
    </ApplicationStateConsumer>
  );
};
export default MainFooter;
